<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <div id="pass1RID">
      <v-card class="ep-rechner-box">
        <v-col cols="12" class="p-0">
          <div class="v-card__title p-0">
            <h2 class="v-card--head--title">
              {{ selectedLang.FirstTrainTile1 }}
            </h2>
          </div>
        </v-col>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2 pb-0">
                  {{ selectedLang.FirstTrainTile17 }}
                </h2>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="strRail">
            <v-col cols="12">
              <v-alert dense type="warning">
                {{ strRailwayText }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <a class="text-decoration-none pl-1" @click="secAlert = !secAlert">
                {{ selectedLang.FirstTrainTile20 }}
              </a><v-alert v-if="secAlert" :value="secAlert" border="top" color="primary" colored-border
                transition="scale-transition" class="text-center">
                <p v-html="selectedLang.FirstTrainTile14"></p>
              </v-alert></v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-2">
              <v-text-field class="pt-0" v-model="bookingCode" :rules="bCRules" :disabled="progress"
                :label="selectedLang.FirstTrainTile2" :hint="selectedLang.FirstTrainTile3" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-2">
              <v-text-field class="pt-0" v-model="travelerName" :rules="tNRules" :disabled="progress"
                :label="selectedLang.FirstTrainTile4" :hint="selectedLang.FirstTrainTile5" required></v-text-field>
            </v-col>
            <v-cols cols="12" class="pt-0 pb-2">
              <p class="text-center mb-0 mt-0" v-html="selectedLang.FirstTrainTile6a">
              </p>
              <p v-if="loading" class="text-center progress-text mb-1 mt-1">{{ selectedLang.FirstTrainTile23 }}</p>
            </v-cols>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row v-if="!progress">
            <v-progress-linear v-if="loading" v-model="pgValue" :active="pgShow" :indeterminate="pgQuery"
              :query="pgQuery"></v-progress-linear>
            <v-col cols="12">
              <v-btn id="search-fl" block :loading="loading" :disabled="!valid || progress || loading"
                class="btn-ep-next-step" @click="validate">
                {{ selectedLang.FirstTrainTile6 }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="progress">
            <v-col cols="12">
              <v-btn block class="btn-ep-back-to" @click="restart">{{
                selectedLang.FirstTrainTile10
              }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-form>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "FirstFlightTile",
  data: function () {
    return {
      bookingCode: "",
      travelerName: "",
      valid: false,
      fromStart: false,
      inBC: "",
      hasAirl: "",
      strRail: false,
      strRailwayText: "",
      loading: false,
      alert: false,
      secAlert: false,
      pgValue: 0,
      pgQuery: false,
      pgShow: true,
      pgInterval: 0,
      showStrCB: false,
    };
  },
  computed: {
    ...mapState([
      "kiofCla",
      "progress",
      "selectedDiv",
      "selectedLang",
      "dataTrain",
      "pass21",
      "bCRules",
      "tNRules",
    ]),
  },
  watch: {
    bookingCode() {
      this.bookingCode = this.bookingCode.replace(" ", "");
      if (this.bookingCode.length >= 2) {
        if (this.bookingCode.match(/(RB|IC|ICE|ME|NWB|EC|RE)\d+/gi)) {
          this.strRail = true;
        } else {
          this.strRail = false;
        }
      } else {
        this.strRail = false;
      }
    },
  },
  mounted: function () {
    this.strRailwayText = this.$store.state.selectedLang.FirstTrainTile15;
  },
  methods: {
    ...mapActions([
      "setSelectedDiv",
      "setVar",
      "getRailData",
      "goToStep",
      "killRun",
    ]),
    restart() {
      this.killRun({ vm: this });
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    queryAndIndeterminate() {
      this.pgQuery = true
      this.pgShow = true
      this.pgValue = 0

      setTimeout(() => {
        this.pgQuery = false
        this.pgInterval = setInterval(() => {
          if (this.pgValue === 100) {
            this.pgInterval = 0;
            this.pgShow = false
            return setTimeout(this.queryAndIndeterminate, 1000)
          }
          this.pgValue += 1
        }, 1000)
      })
    },
    async validate() {
      this.bookingCode = this.bookingCode.toUpperCase().trim();
      this.$store.state.kiofCla = "TRFDB";
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.queryAndIndeterminate();
        await this.getRailData({
          bookingCode: this.bookingCode,
          travelerName: this.travelerName,
        }).then(() => {
          this.loading = false;
          if (Object.keys(this.dataTrain).length == 0) {
            this.setSelectedDiv("32");
          } else {
            var go4ward = true;
            this.dataTrain.kiofCla = "TRFDB";
            if (this.dataTrain.kiof == "six") {
              var splittedDetails = this.dataTrain.details.split(",");
              var nOfRides = 1;
              if (
                splittedDetails[0] == "Hin- und Rückfahrt" ||
                splittedDetails[0] == "Outbound and return journey"
              ) {
                nOfRides = 2;
              }
              this.dataTrain.nOfRides = nOfRides;
              this.dataTrain.tarif = splittedDetails[1];
              this.dataTrain.bookingClass = splittedDetails[2];
              this.dataTrain.nOPa = splittedDetails[3].match(/\d+/s)[0];
              this.dataTrain.start = splittedDetails[4].substr(
                0,
                splittedDetails[4].indexOf("/")
              );
              this.dataTrain.destination = splittedDetails[4].substr(
                splittedDetails[4].indexOf("/") + 1
              );
            }
            this.dataTrain.bookerNameFR = this.travelerName;
            var today = new Date();
            var travelDateString = this.dataTrain.travelDate.split(".");
            var travelDate = new Date(
              travelDateString[2] +
              "-" +
              travelDateString[1] +
              "-" +
              travelDateString[0]
            );
            if (today < travelDate) {
              this.showStrCB = true;
              this.setVar({ pos: "showStrCB", val: this.showStrCB });
            }

            if (this.dataTrain.tarif.includes("Flexpreis") && today < travelDate) {
              go4ward = false;
              this.setVar({ pos: "rejectionMessage", val: this.selectedLang.FirstTrainTile24 });
            }

            if (this.dataTrain.tarif.includes("Flexpreis") && today >= travelDate) {
              this.dataTrain.price = 19.00;
            }

            if ((this.dataTrain.tarif.includes("Sparpreis") && !this.dataTrain.tarif.includes("Super Sparpreis")) && today < travelDate) {
              go4ward = false;
              this.setVar({ pos: "rejectionMessage", val: this.selectedLang.FirstTrainTile25 });
            }

            if (go4ward) {
              this.setVar({
                pos: "selectedCase",
                val: {
                  text: this.selectedLang.FirstTrainTile16,
                  val: "TRFDB",
                  valN: 7,
                },
              });

              if (this.dataTrain.nOfRides == 1 && this.dataTrain.nOPa == 1) {
                this.setSelectedDiv("37");
                // if (this.showStrCB) {
                //   this.setSelectedDiv("37");
                // } else {
                //   this.setSelectedDiv("24");
                // }
                this.dataTrain.trCancelDirection = "outward";
              } else {
                this.setSelectedDiv("21");
              }
              this.setVar({ pos: "dataTrain", val: this.dataTrain });
              this.setVar({ pos: "kiofCla", val: "TRFDB" });
            } else {
              this.setSelectedDiv("32");
            }
          }
        });
        this.goToStep({ vm: this, val: this.selectedDiv });
        this.setVar({ pos: "progress", val: true });
        clearInterval(this.pgInterval);
      }
      this.$gtag.event("1. Zug eingegeben", {
        event_category: "Rechner",
        event_label: "1. Zug eingegeben",
      });
    },
  },
};
</script>
